export class GetCaregiverLogsBo {
    startDate: string | null;
    endDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    statusType: string;
}